<template>
  <div class="error-container">
    <!-- <div class="login-header">
       <div class="login"></div>
    </div> -->
    <el-form ref="errorForm" label-position="left"
             label-width="0px"
             class="card-box error-form">
      <h3 class="title">{{$t("wm_lang_html_c45357")}}</h3>
      <div class="el-error__body">
        <el-form-item>
          <h3 style="line-height:24px;color: #24324c;">{{ errorMsg }}</h3>
        </el-form-item>
        <el-form-item class="tc" style="margin-bottom:0px;">
          <el-button type="primary" @click.native.prevent="close">
            关闭
          </el-button>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
import getErrorMsg from '@/language/getErrorMessage';
import Cookies from 'js-cookie';

export default {
  name: 'Info',
  data() {
    return {
      errorMsg: '',
      errorData: {}
    }
  },
  methods: {
    close() {
      window.close();
    }
  },
  mounted() {
    console.log(this.$route.params)
    let msg = '';
    if (JSON.stringify(this.$route.params) !== '{}') {
      this.errorData = this.$route.params.errorData;
      msg = this.$route.params.errorData.msg;
      Cookies.set('Pwm-login-errorMsg', msg);
    }
    if (this.$route.query) {
      Cookies.set('Pwm-login-errorMsg', getErrorMsg(this.$route.query.code));
    }
    this.errorMsg = Cookies.get('Pwm-login-errorMsg');
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/mixin.scss";

.tips {
  font-size: 14px;
  margin-top: 20px;
  line-height: 21px;
}

.error-container {
  @include relative;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  // background-color: #0661E4;

  input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px #293444 inset !important;
    -webkit-text-fill-color: #fff !important;
  }

  input {
    background: transparent;
    border: 0px;
    -webkit-appearance: none;
    border-radius: 0px;
    padding: 12px 5px 12px 15px;
    color: #eeeeee;
    height: 47px;
  }

  .title {
    font-size: 16px;
    font-weight: 400;
    background: #3986ee;
    color: #fff;
    margin: 0 auto;
    text-align: left;
    padding: 12px 20px !important;
  }

  .error-form {
    position: absolute;
    left: 0;
    right: 0;
    width: 600px;
    margin: 25vh auto;
    box-shadow: 0px 8px 16px -8px rgba(0, 0, 0, 0.16), 0px 12px 32px 0px rgba(0, 0, 0, 0.12), 0px 16px 48px 16px rgba(0, 0, 0, 0.08), 0px 8px 16px -8px rgba(0, 0, 0, 0.16), 0px 12px 32px 0px rgba(0, 0, 0, 0.12), 0px 16px 48px 16px rgba(0, 0, 0, 0.08);
    border-radius: 0px !important;
    border: none !important;
    background: #fff;
  }

  .el-error__body {
    padding: 20px;
  }

  .login-header {
    height: 102px;
    width: 90%;
    position: fixed;
    top: 0;
    left: 5%;

    .login {
      background-image: url('~@/assets/images/logo_pic.png');
      background-size: 80%;
      background-repeat: no-repeat;
      height: 73px;
      width: 194px;
      margin-top: 30px;
    }
  }

  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    /*background: rgba(0, 0, 0, 0.1);*/
    border-radius: 5px;
    color: #454545;
  }

  .el-button {

  }
}

</style>



// WEBPACK FOOTER //
// src/components/views/login/info.vue